import React, { useContext, useEffect, useState } from 'react'
import { ContextUserInfo } from '../MainPanel';
import { ContextNotification, severitys } from '../../../App';
import ConfirmationDialog from '../../../Components/ConfirmationDialog';
import { MdCheck, MdDelete } from 'react-icons/md';
import { Button, IconButton, Tooltip } from '@mui/material';

import { CgToggleOff, CgToggleSquareOff } from "react-icons/cg";
import { BsToggle2Off } from 'react-icons/bs';
import bedApi from '../../../api/bedApi';
import bedReservationApi from '../../../api/bedReservationApi';

const UpdateReserveEventForm = ({ id, isReserve, refreshGrid, disabled }) => {
    const { userInfo, userPermissions, userRoles } = useContext(ContextUserInfo);
    const { open, setOpen } = useContext(ContextNotification);
    const [openUpdateReserveEvent, setOpenUpdateReserveEvent] = useState(false);
    const [submitLoading, setSubmitLoading] = useState(false);
    useEffect(() => {

    }, []);
    const handleOpenUpdateReserveEvent = (id) => {
        setOpenUpdateReserveEvent(true);
    };
    const handleUpdateReserveEvent = () => {
        setSubmitLoading(true);
        bedReservationApi.UpdateReserveEvent(id, isReserve).then((res) => {
            if (res.data.success) {
                setOpen({ IsEnable: true, Message: res.data.message, severity: severitys.success });
                refreshGrid(true)
            }
            else {
                setOpen({ IsEnable: true, Message: res.data.message, severity: severitys.error });
            }
        }).catch(err => {
            if (err.response && err.response.data && err.response.data.errors) {
                setOpen({ IsEnable: true, Message: JSON.stringify(err.response.data.errors), severity: severitys.error });
            }
            else if (err.response && err.response.data) {
                setOpen({ IsEnable: true, Message: JSON.stringify(err.response.data), severity: severitys.error });
            }
            else if (err.message) {
                setOpen({ IsEnable: true, Message: JSON.stringify(err.message), severity: severitys.error });
            }
            else {
                setOpen({ IsEnable: true, Message: JSON.stringify(err), severity: severitys.error });
            }
        }
        ).finally(() => { setOpenUpdateReserveEvent(false); setSubmitLoading(false) });
    };
    return (
        <div>
            <Button variant='contained' disabled={disabled} onClick={() => {
                handleOpenUpdateReserveEvent(id)
            }}>
                {isReserve ? "رزرو" : "انصراف"}
            </Button>
            <ConfirmationDialog
                open={openUpdateReserveEvent}
                handleClose={() => setOpenUpdateReserveEvent(false)}
                func={handleUpdateReserveEvent}
                title={isReserve ? "آیا از رزرو این تخت اطمینان دارید؟" : "آیا از انصراف این رزرو اطمینان دارید؟"}
                loading={submitLoading}
            />
        </div>
    )
}

export default UpdateReserveEventForm